import React, { Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import {
  Toolbar,
  Button,
  TextField,
  Typography,
  IconButton
} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { makeStyles } from '@material-ui/styles';
import { DarkTheme } from '../../ThemeProvider';

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    minHeight: 54
  },

  content: {
    padding: theme.spacing(4)
  },

  sticky: {
    position: 'sticky',
    top: 54,
    zIndex: 10
  },

  flex: {
    flex: 1
  },

  searchField: {
    marginRight: theme.spacing(2)
  },

  backButtonHolder: {
    marginRight: theme.spacing(2)
  }
}));

const CustomToolbar = props => {
  const classes = useStyles();
  return (
    <Fragment>
      {/* <div className={classes.toolbar} /> */}
      <Toolbar
        variant="dense"
        className={classes.sticky}
        style={{ ...props.style }}
      >
        <div className={classes.backButtonHolder}>
          <IconButton
            color="secondary"
            onClick={() =>
              props.backUrl
                ? props.history.push(props.backUrl)
                : props.history.goBack()
            }
          >
            <ChevronLeftIcon />
          </IconButton>
        </div>

        <Typography
          variant="subtitle1"
          color="inherit"
          className={classes.flex}
        >
          {props.location.pathname}
        </Typography>
        {props.children}
        {!props.children && (
          <Fragment>
            <DarkTheme></DarkTheme>
            <Link to={`${props.match.url}/new`}>
              <Button variant="contained" color="primary">
                Add
              </Button>
            </Link>
          </Fragment>
        )}
      </Toolbar>
      {/* {props.loading && <LinearProgress />} */}
    </Fragment>
  );
};

export default withRouter(CustomToolbar);
